import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, InputBase, InputLabel, List, ListItem, ListItemText, MenuItem, Paper, Radio, RadioGroup, Select, Typography } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';

import { openSnackbar } from '../store/slices/SnackbarSlice';

import { InputSearchButtonsStyle, InputSearchStyle } from '../styles/FormStyle';

import { ObtenerMateria } from '../connections/catalogos/MateriaConnection';
import { BuscarExpediente } from '../connections/recepcion/ExpedienteConnection';
import { NuevoExhortoLibrado } from '../connections/tribunal/ExhortoLibradoConnection';
import { ObtenerAutoridadesMaterias } from '../connections/catalogos/AutoridadConnection';
import { BuscarExhortoRecibido } from '../connections/recepcion/ExhortoRecibidoConnection';

import { MateriaProps } from '../interfaces/catalogos/MateriaInterface';
import { AutoridadProps } from '../interfaces/catalogos/AutoridadInterface';
import { NuevoExhortoLibradoParams } from '../interfaces/tribunal/ExhortoLibradoInterface'
import { BuscarExpedienteResponse, defaultExpedienteResponse } from '../interfaces/recepcion/ExpedienteInterface';
import { BuscarExhortoRecibidoResponse, defaultExhortoRecibidoResponse } from '../interfaces/recepcion/ExhortoRecibidoInterface';

interface Props {
    openDialog:          boolean;
    handleCloseDialog:   () => void;
}

type TipoBusquedaType = '' | 'expediente' | 'exhortoRecibido';

export const DialogNuevoExhortoLibrado = ( { openDialog, handleCloseDialog }: Props ) => {

    const dispatch = useDispatch();

    const navigate = useNavigate(); 

    const [loading, setLoading] = useState( false );

    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const [tipoBusqueda, setTipoBusqueda] = useState<TipoBusquedaType>( '' );  

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );
    
    const [numeroExpediente, setNumeroExpediente] = useState( '' );
    const [expediente, setExpediente] = useState<BuscarExpedienteResponse>( defaultExpedienteResponse );

    const [numeroExhorto, setNumeroExhorto] = useState( '' );
    const [exhortoRecibido, setExhortoRecibido] = useState<BuscarExhortoRecibidoResponse>( defaultExhortoRecibidoResponse );

    const handleNuevoExhortoLibrado = async () => {      

        const params: NuevoExhortoLibradoParams = {
            idExpediente:       expediente.idExpediente,
            idExhortoRecibido:  exhortoRecibido.idExhortoRecibido,
        };

        setLoadingGuardar( true );

        await NuevoExhortoLibrado( params ).then( resp => {

            setTimeout(() => {

                const { success, message, idExhortoLibrado } = resp;

                if( success )   {

                    setLoadingGuardar( false ); 
                    navigate(`/tribunal/exhorto-librado/elaborar/${ idExhortoLibrado }`);
                    
                } 
                else {                
                        
                    setLoadingGuardar( false ); 
                    dispatch( openSnackbar({ message, variant: 'error' }) );    
                }

            }, 700);

        });

    }

    const handleBuscarExpediente = async () => {

        setLoading( true ); 

        await BuscarExpediente({ numeroExpediente, idAutoridad: autoridad }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if( success ){

                    handleClear();

                    setExpediente( resp );
                    setLoading( false );                     

                    
                }
                else {                    
                        
                    handleClear();
                    setLoading( false ); 
                    
                    dispatch( openSnackbar({ message, variant: 'error' }) );                        
                    
                }

            }, 700);  

        });    

    }

    const handleBuscarExhortoRecibido = async () => {

        setLoading( true ); 

        await BuscarExhortoRecibido({ numeroExhortoRecibido: numeroExhorto, idAutoridad: autoridad }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if( success ){

                    handleClear();

                    setExhortoRecibido( resp );
                    setLoading( false );                     

                    
                }
                else {                    
                        
                    handleClear();
                    setLoading( false ); 
                    
                    dispatch( openSnackbar({ message, variant: 'error' }) );                        
                    
                }

            }, 700);  

        });    

    }

    const handleClear = () => {
        
        setMateria( 0 );
        setAutoridad( 0 );
        setAutoridadArray( [] );

        setNumeroExpediente( '' );
        setExpediente( defaultExpedienteResponse );

        setNumeroExhorto( '' );
        setExhortoRecibido( defaultExhortoRecibidoResponse );

    }

    const handleCerrarDialog = () => {
        
        setTipoBusqueda( '' );

        handleClear();
        handleCloseDialog();

    }

    const handleChangeTipoBusqueda = ( value: TipoBusquedaType ) => {

        setNumeroExpediente( '' );
        setExpediente( defaultExpedienteResponse );

        setNumeroExhorto( '' );
        setExhortoRecibido( defaultExhortoRecibidoResponse );

        setTipoBusqueda( value );
    }

    useEffect(() => {
        
        async function Obtener(){    

            await ObtenerMateria().then( resp => {              
                setMateriaArray( resp );                 
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {

        async function Obtener(){    

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {              
                setAutoridadArray( resp );                 
            });

        }

        if( materia !== 0 ){
            Obtener();
        }

    }, [ materia ]);

    return (
        <>

            <Dialog open={ openDialog } maxWidth='md' fullWidth={true} >

                <DialogTitle>Nuevo exhorto librado</DialogTitle>
            
                <DialogContent>
                    
                    <Grid container spacing={3} mt={1}>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl>

                                <FormLabel>Generar acuerdo para:</FormLabel>
                                <RadioGroup row>    

                                    <FormControlLabel 
                                        label="Expediente" 
                                        control={ <Radio checked={ tipoBusqueda === 'expediente' } 
                                        onChange={ () => handleChangeTipoBusqueda('expediente') } />} 
                                    />  

                                    <FormControlLabel 
                                        label="Exhorto recibido" 
                                        control={ <Radio checked={ tipoBusqueda === 'exhortoRecibido' } 
                                        onChange={ () => handleChangeTipoBusqueda('exhortoRecibido') } />} 
                                    />                                        
                                      
                                </RadioGroup>

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 4 }}>
                                                                    
                            <FormControl required fullWidth>
                                
                                <InputLabel>Materia</InputLabel>
                            
                                <Select                                                                          
                                    label="Materia"
                                    value={ materia }
                                    onChange={ ( e ) => setMateria( parseInt( e.target.value.toString() ) ) }
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                    {
                                        materiaArray
                                        .filter( (e) => e.idMateria === 5 || e.idMateria === 6 )
                                        .map( ( e ) => (
                                            <MenuItem key={ e.idMateria } value={ e.idMateria }>{ e.descripcion }</MenuItem>                                                        
                                        ))
                                    }                     
                                    
                                </Select>

                            </FormControl>

                        </Grid>   

                        <Grid size={{ xs: 12, md: 8 }}>
                        
                            <FormControl required fullWidth>
                                
                                <InputLabel>Autoridad</InputLabel>
                            
                                <Select                                                                          
                                    label="Autoridad"
                                    value={ autoridad }
                                    onChange={ ( e ) => setAutoridad( parseInt( e.target.value.toString() ) ) }
                                    disabled={ materia === 0 }
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                    {
                                        autoridadArray.map( ( e ) => (
                                            <MenuItem key={ e.idAutoridad } value={ e.idAutoridad }>{ e.descripcion }</MenuItem>                                                        
                                        ))
                                    }                     
                                    
                                </Select>

                            </FormControl>

                        </Grid>         

                        {/* ---------------------  Busqueda por expediente  -------------------------------------- */}
                        
                        {
                            tipoBusqueda === 'expediente' 
                            && 
                                <Grid size={12}> 

                                    <Paper
                                        component="div"
                                        sx={ InputSearchStyle }
                                    >                    
                                        
                                        <InputBase 
                                            sx={{ ml: 1, flex: 1 }}                        
                                            placeholder="Buscar por número de expediente"     
                                            value={ numeroExpediente } 
                                            onChange={ ( e ) => { setNumeroExpediente( e.target.value ) }}
                                        />

                                        <Button 
                                            type="button" 
                                            variant='contained'                                  
                                            size='small'
                                            sx={ InputSearchButtonsStyle } 
                                            loading={ loading }
                                            disabled={ autoridad === 0 }
                                            onClick={ handleBuscarExpediente }
                                        >
                                            <SearchIcon />
                                        </Button>            

                                    </Paper>
                                    
                                </Grid>
                        }         

                        {
                            expediente.success
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>
    
                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>
    
                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography> }
                                                    secondary={ 
                                                        expediente.numeroFolio
                                                        ?
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.numeroExpediente } (F. { expediente.numeroFolio }) </Typography> 
                                                        :
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.numeroExpediente } </Typography> 
                                                    }
                                                />
    
                                            </ListItem>
    
                                        </List>
                                        
                                    </Grid>           
                                    
                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.tipoJuicio } </Typography> }
                                                />

                                            </ListItem>

                                        </List>
                                    
                                    </Grid> 

                                    {
                                        expediente.actores.length !== 0 
                                        &&                              
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            expediente.actores.map( ( actor, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}> { actor } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }                                                        
                                                                    </List>       
                                                                </>                                                         
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                    {
                                        expediente.demandados.length !== 0 
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            expediente.demandados.map( ( demandado, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}> { demandado } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }                                                        
                                                                    </List>          
                                                                </>                                                      
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                </>
                        }

                        {/* ---------------------  Busqueda por exhorto recibido  -------------------------------------- */}
                          
                        {
                            tipoBusqueda === 'exhortoRecibido' 
                            && 
                                <Grid size={12}> 

                                    <Paper
                                        component="div"
                                        sx={ InputSearchStyle }
                                    >                    
                                        
                                        <InputBase 
                                            sx={{ ml: 1, flex: 1 }}                        
                                            placeholder="Buscar por número de exhorto"     
                                            value={ numeroExhorto } 
                                            onChange={ ( e ) => setNumeroExhorto( e.target.value ) }
                                        />

                                        <Button 
                                            type="button" 
                                            variant='contained'                                  
                                            size='small'
                                            sx={ InputSearchButtonsStyle } 
                                            loading={ loading }
                                            disabled={ autoridad === 0 }
                                            onClick={ handleBuscarExhortoRecibido }
                                        >
                                            <SearchIcon />
                                        </Button>            

                                    </Paper>
                                    
                                </Grid>
                        }      

                        {
                            exhortoRecibido.success
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>
    
                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>
    
                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de exhorto: </Typography> }
                                                    secondary={ 
                                                        exhortoRecibido.numeroFolio
                                                        ?
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExhorto } (F. { exhortoRecibido.numeroFolio }) </Typography> 
                                                        :
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExhorto } </Typography> 
                                                    }
                                                />
    
                                            </ListItem>
    
                                        </List>
                                        
                                    </Grid>         

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.tipoJuicio } </Typography> }
                                                />

                                            </ListItem>

                                        </List>
                                    
                                    </Grid>   
                                    
                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente de origen: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.numeroExpedienteOrigen } </Typography> }
                                                />

                                            </ListItem>

                                        </List>
                                    
                                    </Grid> 

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>
                            
                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Autoridad del exhorto: </Typography> }
                                                    secondary={ <Typography variant='subtitle2' fontWeight={'bold'}> { exhortoRecibido.autoridadExhortoRecibido } </Typography> }
                                                />

                                            </ListItem>

                                        </List>
                                    
                                    </Grid>             

                                    {
                                        exhortoRecibido.actores.length !== 0 
                                        &&                              
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            exhortoRecibido.actores.map( ( actor, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}> { actor } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }                                                        
                                                                    </List>     
                                                                </>                                                           
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                    {
                                        exhortoRecibido.demandados.length !== 0 
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>
                                    
                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={ <Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography> }
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                        {
                                                                            exhortoRecibido.demandados.map( ( demandado, index ) => (
                                                                                <ListItem key={ index } sx={{ py: 0, px: 0 }}>
                                                                                    <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}> { demandado } </Typography>
                                                                                </ListItem>
                                                                            ))
                                                                        }                                                        
                                                                    </List>   
                                                                </>                                                             
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>
                                            
                                            </Grid> 
                                    }

                                </>
                        }

                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button color='secondary' disabled={ loadingGuardar } onClick={ handleCerrarDialog }>Cancelar</Button>
                    <Button 
                        variant="contained" 
                        loading={ loadingGuardar } 
                        onClick={ handleNuevoExhortoLibrado }
                        disabled={
                            tipoBusqueda === '' ||
                            ( autoridad === 0 && !expediente.success && !exhortoRecibido.success ) ||
                            ( tipoBusqueda === 'expediente' && !expediente.success ) ||
                            ( tipoBusqueda === 'exhortoRecibido' && !exhortoRecibido.success )
                        }
                    >
                        Guardar
                    </Button>
                </DialogActions>

            </Dialog>

        </>
    )
}